import PrestationDetailController from './prestation.detail.controller';

export default {
    template: require('./prestation.detail.html'),
    controller: PrestationDetailController
};
